//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"Angle",1,0],[0,"MaxWallHeight",1,0],[0,"Point",1,"Point",0],[0,"TiltAngleType",1,0],[0,"Type",1,0]],[[["count","curves"],"GetCurves",{},0,0],[["curves"],"SetCurves",{},1,0]],[]];
SPLM.CAM.ToolAxisTilt = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolAxisTilt";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolAxisTilt.Types = Object.freeze({
    "None" : "None", "AwayFromPart" : "AwayFromPart", "AwayFromPoint" : "AwayFromPoint", "TowardPoint" : "TowardPoint", "AwayFromCurve" : "AwayFromCurve", "TowardCurve" : "TowardCurve"});

SPLM.CAM.ToolAxisTilt.TiltAngleTypes = Object.freeze({
    "Automatic" : "Automatic", "Specify" : "Specify"});

export default SPLM;